export default {
	title: 'settings',
	components: [
		{ title: 'input_output', component: 'input_output_010' },
		{ title: 'input_type', component: 'input_type_per_id_g2' },
		{ title: 'enable_input', component: 'enable_input_g2', min_ver: '1.0.7' },
		{
			title: 'operational_mode',
			component: 'operational_mode_g2',
			min_ver: '1.0.7',
		},
		{ title: 'invert_input', component: 'input_invert_per_id_g2' },
		{ title: 'input_name', component: 'input_name_per_id_g2' },
		{ title: 'button_fade_rate', component: 'button_fade_rate_g2' },
		{ title: 'button_presets', component: 'button_presets_g2' },
		{
			title: 'min_brightness_on_toggle',
			component: 'min_brightness_on_toggle_g2',
		},
		{ title: 'range_map', component: 'range_map_g2', requires_config_key: 'range_map' },
		{ title: 'transition_duration', component: 'transition_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
